// ISO 3166-1 alpha-2 codes + Arabic names. Flags loaded from flagcdn.com by code.
// Sorted by Arabic alphabet on use; here in alpha-2 order for diff-friendliness.

const COUNTRIES = [
    ['AD', 'أندورا'],
    ['AE', 'الإمارات العربية المتحدة'],
    ['AF', 'أفغانستان'],
    ['AG', 'أنتيغوا وباربودا'],
    ['AI', 'أنغويلا'],
    ['AL', 'ألبانيا'],
    ['AM', 'أرمينيا'],
    ['AO', 'أنغولا'],
    ['AQ', 'أنتاركتيكا'],
    ['AR', 'الأرجنتين'],
    ['AS', 'ساموا الأمريكية'],
    ['AT', 'النمسا'],
    ['AU', 'أستراليا'],
    ['AW', 'أروبا'],
    ['AX', 'جزر أولاند'],
    ['AZ', 'أذربيجان'],
    ['BA', 'البوسنة والهرسك'],
    ['BB', 'باربادوس'],
    ['BD', 'بنغلاديش'],
    ['BE', 'بلجيكا'],
    ['BF', 'بوركينا فاسو'],
    ['BG', 'بلغاريا'],
    ['BH', 'البحرين'],
    ['BI', 'بوروندي'],
    ['BJ', 'بنين'],
    ['BL', 'سان بارتيلمي'],
    ['BM', 'برمودا'],
    ['BN', 'بروناي'],
    ['BO', 'بوليفيا'],
    ['BQ', 'الجزر الكاريبية الهولندية'],
    ['BR', 'البرازيل'],
    ['BS', 'باهاماس'],
    ['BT', 'بوتان'],
    ['BV', 'جزيرة بوفيه'],
    ['BW', 'بوتسوانا'],
    ['BY', 'بيلاروسيا'],
    ['BZ', 'بليز'],
    ['CA', 'كندا'],
    ['CC', 'جزر كوكوس'],
    ['CD', 'جمهورية الكونغو الديمقراطية'],
    ['CF', 'جمهورية أفريقيا الوسطى'],
    ['CG', 'جمهورية الكونغو'],
    ['CH', 'سويسرا'],
    ['CI', 'ساحل العاج'],
    ['CK', 'جزر كوك'],
    ['CL', 'تشيلي'],
    ['CM', 'الكاميرون'],
    ['CN', 'الصين'],
    ['CO', 'كولومبيا'],
    ['CR', 'كوستاريكا'],
    ['CU', 'كوبا'],
    ['CV', 'الرأس الأخضر'],
    ['CW', 'كوراساو'],
    ['CX', 'جزيرة عيد الميلاد'],
    ['CY', 'قبرص'],
    ['CZ', 'التشيك'],
    ['DE', 'ألمانيا'],
    ['DJ', 'جيبوتي'],
    ['DK', 'الدنمارك'],
    ['DM', 'دومينيكا'],
    ['DO', 'جمهورية الدومينيكان'],
    ['DZ', 'الجزائر'],
    ['EC', 'الإكوادور'],
    ['EE', 'إستونيا'],
    ['EG', 'مصر'],
    ['EH', 'الصحراء الغربية'],
    ['ER', 'إريتريا'],
    ['ES', 'إسبانيا'],
    ['ET', 'إثيوبيا'],
    ['FI', 'فنلندا'],
    ['FJ', 'فيجي'],
    ['FK', 'جزر فوكلاند'],
    ['FM', 'ميكرونيزيا'],
    ['FO', 'جزر فارو'],
    ['FR', 'فرنسا'],
    ['GA', 'الغابون'],
    ['GB', 'المملكة المتحدة'],
    ['GD', 'غرينادا'],
    ['GE', 'جورجيا'],
    ['GF', 'غويانا الفرنسية'],
    ['GG', 'غيرنزي'],
    ['GH', 'غانا'],
    ['GI', 'جبل طارق'],
    ['GL', 'جرينلاند'],
    ['GM', 'غامبيا'],
    ['GN', 'غينيا'],
    ['GP', 'غوادلوب'],
    ['GQ', 'غينيا الاستوائية'],
    ['GR', 'اليونان'],
    ['GS', 'جورجيا الجنوبية وجزر ساندويتش الجنوبية'],
    ['GT', 'غواتيمالا'],
    ['GU', 'غوام'],
    ['GW', 'غينيا بيساو'],
    ['GY', 'غيانا'],
    ['HK', 'هونغ كونغ'],
    ['HM', 'جزيرة هيرد وجزر ماكدونالد'],
    ['HN', 'هندوراس'],
    ['HR', 'كرواتيا'],
    ['HT', 'هايتي'],
    ['HU', 'المجر'],
    ['ID', 'إندونيسيا'],
    ['IE', 'أيرلندا'],
    ['IL', 'إسرائيل'],
    ['IM', 'جزيرة مان'],
    ['IN', 'الهند'],
    ['IO', 'إقليم المحيط الهندي البريطاني'],
    ['IQ', 'العراق'],
    ['IR', 'إيران'],
    ['IS', 'آيسلندا'],
    ['IT', 'إيطاليا'],
    ['JE', 'جيرسي'],
    ['JM', 'جامايكا'],
    ['JO', 'الأردن'],
    ['JP', 'اليابان'],
    ['KE', 'كينيا'],
    ['KG', 'قيرغيزستان'],
    ['KH', 'كمبوديا'],
    ['KI', 'كيريباتي'],
    ['KM', 'جزر القمر'],
    ['KN', 'سانت كيتس ونيفيس'],
    ['KP', 'كوريا الشمالية'],
    ['KR', 'كوريا الجنوبية'],
    ['KW', 'الكويت'],
    ['KY', 'جزر كايمان'],
    ['KZ', 'كازاخستان'],
    ['LA', 'لاوس'],
    ['LB', 'لبنان'],
    ['LC', 'سانت لوسيا'],
    ['LI', 'ليختنشتاين'],
    ['LK', 'سريلانكا'],
    ['LR', 'ليبيريا'],
    ['LS', 'ليسوتو'],
    ['LT', 'ليتوانيا'],
    ['LU', 'لوكسمبورغ'],
    ['LV', 'لاتفيا'],
    ['LY', 'ليبيا'],
    ['MA', 'المغرب'],
    ['MC', 'موناكو'],
    ['MD', 'مولدوفا'],
    ['ME', 'الجبل الأسود'],
    ['MF', 'سانت مارتن (الجزء الفرنسي)'],
    ['MG', 'مدغشقر'],
    ['MH', 'جزر مارشال'],
    ['MK', 'مقدونيا الشمالية'],
    ['ML', 'مالي'],
    ['MM', 'ميانمار'],
    ['MN', 'منغوليا'],
    ['MO', 'ماكاو'],
    ['MP', 'جزر ماريانا الشمالية'],
    ['MQ', 'مارتينيك'],
    ['MR', 'موريتانيا'],
    ['MS', 'مونتسرات'],
    ['MT', 'مالطا'],
    ['MU', 'موريشيوس'],
    ['MV', 'جزر المالديف'],
    ['MW', 'مالاوي'],
    ['MX', 'المكسيك'],
    ['MY', 'ماليزيا'],
    ['MZ', 'موزمبيق'],
    ['NA', 'ناميبيا'],
    ['NC', 'كاليدونيا الجديدة'],
    ['NE', 'النيجر'],
    ['NF', 'جزيرة نورفولك'],
    ['NG', 'نيجيريا'],
    ['NI', 'نيكاراغوا'],
    ['NL', 'هولندا'],
    ['NO', 'النرويج'],
    ['NP', 'نيبال'],
    ['NR', 'ناورو'],
    ['NU', 'نيوي'],
    ['NZ', 'نيوزيلندا'],
    ['OM', 'عُمان'],
    ['PA', 'بنما'],
    ['PE', 'بيرو'],
    ['PF', 'بولينزيا الفرنسية'],
    ['PG', 'بابوا غينيا الجديدة'],
    ['PH', 'الفلبين'],
    ['PK', 'باكستان'],
    ['PL', 'بولندا'],
    ['PM', 'سان بيير وميكلون'],
    ['PN', 'جزر بيتكيرن'],
    ['PR', 'بورتوريكو'],
    ['PS', 'فلسطين'],
    ['PT', 'البرتغال'],
    ['PW', 'بالاو'],
    ['PY', 'باراغواي'],
    ['QA', 'قطر'],
    ['RE', 'لا ريونيون'],
    ['RO', 'رومانيا'],
    ['RS', 'صربيا'],
    ['RU', 'روسيا'],
    ['RW', 'رواندا'],
    ['SA', 'المملكة العربية السعودية'],
    ['SB', 'جزر سليمان'],
    ['SC', 'سيشل'],
    ['SD', 'السودان'],
    ['SE', 'السويد'],
    ['SG', 'سنغافورة'],
    ['SH', 'سانت هيلينا'],
    ['SI', 'سلوفينيا'],
    ['SJ', 'سفالبارد ويان ماين'],
    ['SK', 'سلوفاكيا'],
    ['SL', 'سيراليون'],
    ['SM', 'سان مارينو'],
    ['SN', 'السنغال'],
    ['SO', 'الصومال'],
    ['SR', 'سورينام'],
    ['SS', 'جنوب السودان'],
    ['ST', 'ساو تومي وبرينسيب'],
    ['SV', 'السلفادور'],
    ['SX', 'سانت مارتن (الجزء الهولندي)'],
    ['SY', 'سوريا'],
    ['SZ', 'إسواتيني'],
    ['TC', 'جزر توركس وكايكوس'],
    ['TD', 'تشاد'],
    ['TF', 'الأقاليم الجنوبية الفرنسية'],
    ['TG', 'توغو'],
    ['TH', 'تايلاند'],
    ['TJ', 'طاجيكستان'],
    ['TK', 'توكيلاو'],
    ['TL', 'تيمور الشرقية'],
    ['TM', 'تركمانستان'],
    ['TN', 'تونس'],
    ['TO', 'تونغا'],
    ['TR', 'تركيا'],
    ['TT', 'ترينيداد وتوباغو'],
    ['TV', 'توفالو'],
    ['TW', 'تايوان'],
    ['TZ', 'تنزانيا'],
    ['UA', 'أوكرانيا'],
    ['UG', 'أوغندا'],
    ['UM', 'جزر الولايات المتحدة الصغيرة النائية'],
    ['US', 'الولايات المتحدة'],
    ['UY', 'الأوروغواي'],
    ['UZ', 'أوزبكستان'],
    ['VA', 'الفاتيكان'],
    ['VC', 'سانت فينسنت والغرينادين'],
    ['VE', 'فنزويلا'],
    ['VG', 'جزر العذراء البريطانية'],
    ['VI', 'جزر العذراء الأمريكية'],
    ['VN', 'فيتنام'],
    ['VU', 'فانواتو'],
    ['WF', 'واليس وفوتونا'],
    ['WS', 'ساموا'],
    ['XK', 'كوسوفو'],
    ['YE', 'اليمن'],
    ['YT', 'مايوت'],
    ['ZA', 'جنوب أفريقيا'],
    ['ZM', 'زامبيا'],
    ['ZW', 'زمبابوي'],
];

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES);

export const FLAG_BASE = 'https://flagcdn.com';

export function flagUrl(code, { size = 'w40' } = {}) {
    if (!code) return null;
    // flagcdn supports: w20, w40, w80, w160, w320, w640, w1280, w2560, w2880
    // plus .svg for vector. We use raster for predictable sizing.
    return `${FLAG_BASE}/${size}/${code.toLowerCase()}.png`;
}

export default COUNTRIES;
